import { IProgression } from 'utility-js-progression';
import { ICommand, IDefineCommand, IDatasource, IQueryMediator, key } from 'core-ts-types';

angular.module('capability-ng-user-app').factory(
  'saveAdditionalInformationCommand',
  (defineCommand: IDefineCommand, QueryMediator: IQueryMediator, $http: ng.IHttpService): ICommand => {
    return defineCommand('saveAdditionalInformationCommand', function updateTransferProgress(
      deferred: ng.IDeferred<void>,
      additionalInfo: Record<string, any>
    ): void {
      $http({
        method: 'PATCH',
        url: 'student/profile/',
        data: additionalInfo
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          deferred.resolve();
        })
        .catch((error: ng.IHttpPromiseCallbackArg<any>): any => {
          deferred.reject(error);
        });
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/save_additional_information_command.ts